<template>
	<v-dialog
			content-class="rounded-xl"
			persistent
			scrollable
			width="400" :value="true"
	>
		<v-card class="position-relative" rounded="xl">
			<v-card-text class="pa-4 text-body-2">
				<mobile-pass-preview inModal :preview-url="previewUrl"/>
			</v-card-text>

			<v-card-actions class="justify-end py-4">
				<v-btn
						v-if="continueText"
						class="me-2 me-md-4 rounded-lg"
						color="grey darken-1"
						depressed
						text
						@click="$emit('reject-preview')"
				>
					{{ continueText }}
				</v-btn>
				<v-btn
						v-if="submitText"
						class="rounded-lg"
						color="primary"
						depressed
						@click="$emit('accept-preview')"
				>
					{{ submitText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'MobilePassPreviewModal',
	props: {
		previewUrl: String,
		continueText: {
			type: String,
			default: 'Continue Editing'
		},
		submitText: {
			type: String,
			default: 'Submit'
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
	height: calc(100% - 3rem) !important;
	max-height: 900px !important;

	& .v-card__text {
		background: #f0f0f0 !important;
		border: none !important;
	}
}
</style>